class RequestValue<T> {
  private header: T | null = null
  constructor(_header?: T) {
    this.header = _header || null
  }
  
  get = () => this.header
  set = (token: T) => { this.header = token }
  destroy = () => { this.header = null }
}

const RequestManager = () => {
  const jwt = new RequestValue<string>()
  const isBlocked = new RequestValue(false)
  return {
    jwt,
    isBlocked
  }
}

export default RequestManager()